<template>
    <div>
        <!-- 认证弹窗 -->
        <el-dialog :visible.sync="showForm" @close="closeModal" width="420px">
            <el-form :model="bindNameForm" ref="bindNameForm" :rules="rules">
                <el-form-item label="真实姓名:" prop="realName">
                    <el-input v-model="bindNameForm.realName"></el-input>
                </el-form-item>
                <el-form-item label="身份证号:" prop="identityId">
                    <el-input v-model="bindNameForm.identityId"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="width:100%;" size="large" type="primary" @click="bindRequest('bindNameForm')">提交后,支付宝扫码验证</el-button>
                </el-form-item>
            </el-form>

            <div class="agree_text">
                <div class="title">
                    <el-checkbox v-model="isChecked"></el-checkbox><span>同意</span><a @click="showAgreement = !showAgreement">《支付宝芝麻认证授权协议》</a>
                </div>
                <p v-show="showAgreement">为更好的享受{{$store.state.agentInfo.name}}提供的服务，本人知晓并同意芝麻信用有权基于提供征信服务的需要向合法保存有本人信息的机构采集本人信息（包括由{{$store.state.agentInfo.name}}有权将本人在使用其服务过程中提交或产生的信息提供给芝麻信用），用于验证本人信息的真实性及提供征信服务使用。本人授权芝麻信用，可根据{{$store.state.agentInfo.name}}的查询指令，向其提供相关信息的真实性判断结果及本人的信用信息，用以交易决策使用。</p>
            </div>

            <p slot="footer"></p>
        </el-dialog>

        <!-- 扫码弹窗 -->
        <el-dialog :visible.sync="showImgCode" custom-class="img_modal" width="420px">
            <div class="img_box">
                <!-- <canvas id="qrccode-canvas"></canvas> -->
                <img class="alipay_img" :src="url" alt="">
                <img src="https://image.shoukala.com/image/shoukala_new/alipay_img.png" alt="支付宝扫码">
            </div>
            <p class="tips">使用手机支付宝  扫描二维码认证</p>
            <div class="btn_box">
                <el-button type="primary" size="large" style="float:left;" @click="confirmCert">已认证,刷新状态</el-button>
                <el-button type="default" size="large" style="float:right;"  @click="cancelCert">信息有误,重新输入</el-button>
            </div>
            <p slot="footer"></p>
        </el-dialog>
	</div>
</template>

<script>
import {alipayCertification, alipayCertQuery} from '@/api/userinfo.js';
import qrCode from 'qrcode'
var canvas = '';
export default {
    data(){
        // 校验规范
        const isEmpty = (rule,value,callback) => {
            if(value == ''){
                callback(new Error('不能为空'))
            }else{
                callback()
            }
        };
        const isName = (rule,value,callback) => {
            let reg = /[`~!@#$%^&*()+=|{}':;',\[\].<>/?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？]/;
            if(value == ''){
            callback(new Error('请输入真实姓名'))
            }else if(value.length > 12){
            callback(new Error('姓名长度不合法'))
            }else if(reg.test(value)){
            callback(new Error('姓名不可包含特殊字符'))
            }else{
            callback()
            }
        };
        
        const isCardNo = (rule,value,callback) => {
            let reg = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
            if(value == ''){
            callback(new Error('请输入身份证号'))
            }else if(!reg.test(value)){
            callback(new Error('请输入正确的身份证号'))
            }else{
            callback()
            }
        };
        return{
            bindNameForm: {
                realName: '',
                identityId: ''
            },
            disButton: false,
            //校验
            rules:{
                realName:[{ validator:isName, trigger:'blur' }],
                identityId:[{ validator:isCardNo, trigger:'blur' }]
            },
            isChecked: true,
            showAgreement: false,
            showImgCode: false, //显示二维码
            bizNo:'',
            url: ''
        }
    },
    computed:{
        showForm:{
            get: function() {
                return this.showmodal
            },
            set: function() {
            }
        }
    },
    props:['showmodal'],
    created(){
        
    },
    mounted () {

    },
    methods:{
        //点击绑定按钮
        bindRequest(formName){
            this.$refs[formName].validate((valid) => {
                if(valid){
                    if(!this.isChecked){
                        this.$message.success('请同意协议!');
                    }
                    else{
                        let submitData = {
                            'name': this.bindNameForm.realName,
                            'idcard': this.bindNameForm.identityId
                        };
                        alipayCertification(submitData).then(res => {
                            if(res.data.code == '100001'){
                                this.showImgCode = true;
                                this.$emit('modal-off');
                                this.bizNo = res.data.result.bizno;
                                qrCode.toDataURL(res.data.result.url, {width:152, margin:0}, (error, url) => {
                                    if (error) {
                                        console.log(error)
                                    } else {
                                        this.url = url
                                        //console.log('success')
                                    }
                                })
                            }
                        })
                    }
                }   
                else{
                    return false
                }
            })
        },
        //关闭弹窗
        closeModal(){
            if(this.$refs.bindNameForm){
                this.$refs.bindNameForm.resetFields();
            }
            if(this.$refs.bindAlipayForm){
                this.$refs.bindAlipayForm.resetFields();
            }
            this.$emit('modal-off');
        },

        //已完成认证
        confirmCert(){
            alipayCertQuery({'bizNo': this.bizNo}).then(res => {
                if(res.data.code == '100001'){
                    this.showImgCode = false;
                    //回传给父组件,再次进行认证状态验证
                    // this.$emit('finishCert')
                    this.$store.dispatch('getCertification', true);
                }
            })
            
        },

        //重新认证
        cancelCert(){
            this.showImgCode = false;
            this.$emit('modal-on');
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .ivu-modal-body{
    width:84%;
    margin: 0 auto;
    padding-top: 44px;
    padding-bottom: 40px;
} 

.agree_text{
    margin-top: -10px;
    .title{
        margin: 0 auto;
        text-align: center;
    }
    p{  
        font-size: 12px;
        color: #666666;
        line-height: 22px;
        margin-top: 18px;
    }
}
.img_modal{
    .tips{
        text-align: center;
        font-size: 20px;
        color: #333333;
        margin: 30px 0 10px 0;
    }
    .btn_box{
        width:94%;
        margin: 0 auto 40px;
    }
    .img_box{
        img{
            display: inline-block;
            margin-left: 15px;
        }
        .alipay_img {
            height: 152px;
            width: 152px;
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/components/common/certification.vue